module.exports = __webpack_public_path__ + "static/PressRelease_en-0962d8c9641f1645178291df70924c83.pdf";